import React from 'react';
import { css, cx } from '@emotion/css';
const adornmentStyles = css `
  padding: 4px;
`;
export const Adornment = ({ testId, render, position, additionalStyles }) => {
    if (!render) {
        return null;
    }
    let adornmentTestId;
    if (testId) {
        adornmentTestId = position == 'start' ? `${testId}-start-adornment` : `${testId}-end-adornment`;
    }
    return React.cloneElement(render, {
        className: cx(adornmentStyles, render.props?.className, additionalStyles),
        'data-testid': adornmentTestId,
    });
};
